var render = function render(){var _vm=this,_c=_vm._self._c;return _c('detail',{attrs:{"on-manager":_vm.onManager,"data":_vm.data,"base-info":_vm.baseInfo,"extra-info":_vm.extraInfo,"resource":"inter_vpc_networks","statusModule":"vpcNetwork","hiddenKeys":['tenant', 'project_domain', 'region', 'zone']}})
}
var staticRenderFns = []

export { render, staticRenderFns }